module.exports = __webpack_public_path__ + "img/universe_new1.68362042.jpg";